import { render, staticRenderFns } from "./JournalNotificationView.vue?vue&type=template&id=1ea06682&scoped=true&"
import script from "./JournalNotificationView.vue?vue&type=script&lang=js&"
export * from "./JournalNotificationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea06682",
  null
  
)

export default component.exports